"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useContextMenu = exports.context = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
exports.context = React.createContext(null);
const useContextMenu = () => React.useContext(exports.context);
exports.useContextMenu = useContextMenu;
